import React from 'react';
import { MediaPlayer } from '@uncinc/uncinc-react-kitchen-sink';
import { MediaPlayerProps } from '@uncinc/uncinc-react-kitchen-sink/dist/components/MediaPlayer/types';

const MediaPlayerCustom: React.FC<MediaPlayerProps> = (props) => (
  <MediaPlayer {...props} />
);

export default MediaPlayerCustom;
